module.exports = __webpack_public_path__ + "static/media/chat09.c41fc559.gif";